<template>
  <div class="home">
    <div class="userInfo">
      <div class="header">
        <div class="pHeader">
          <h3>项目编辑</h3>
        </div>
        <div class="line"></div>
      </div>
      <div class="upload">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="1rem"
          class="demo-ruleForm"
        >
          <el-form-item label="项目名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="项目编号" prop="itemserial">
            <el-input v-model="ruleForm.itemserial"></el-input>
          </el-form-item>
          <el-form-item label="募集金额" prop="placement">
            <el-input v-model.number="ruleForm.placement"></el-input>
          </el-form-item>
          <el-form-item label="账户信息" prop="account">
            <el-input v-model="ruleForm.account"></el-input>
          </el-form-item>
          <el-form-item label="发起时间" prop="donatime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.donatime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="捐赠要求" prop="donatefor">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="ruleForm.donatefor"
            ></el-input>
          </el-form-item>
          <el-form-item label="申请条件" prop="applyfor">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="ruleForm.applyfor"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="fileShow">
              <span>项目封面</span>
              <el-upload
                class="avatar-uploader"
                action="http://123.56.170.62:9999/tianwei/twdonateitem"
                ref="pictUpload"
                :show-file-list="false"
                list-type="picture-card"
                :on-change="picthandleChange"
                :before-upload="pictbeforeAvatarUpload"
                :auto-upload="false"
              >
                <img
                  v-if="ruleForm.picture"
                  :src="ruleForm.picture"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <span style="margin-left: 0.2rem">项目视频（选填）</span>
              <el-upload
                class="avatar-uploader"
                action="http://123.56.170.62:9999/tianwei/twdonateitem"
                ref="videoUpload"
                :show-file-list="false"
                list-type="picture-card"
                :on-change="fpicthandleChange"
                :before-upload="fpictbeforeAvatarUpload"
                :auto-upload="false"
              >
                <video
                  v-if="ruleForm.video"
                  :src="ruleForm.video"
                  controls="controls"
                >
                  your browser does not support the video tag
                </video>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="项目详情" prop="donateask">
            <Editor ref="editEditor" :catchData="catchData"></Editor>
          </el-form-item>
          <!-- 上传显示进度条 -->
          <div v-show="progressFlag" class="process">
            <el-progress
              :text-inside="true"
              :stroke-width="14"
              :percentage="progressPercent"
              status="format"
            ></el-progress>
            <p>请耐心等待进度条完成，否则容易上传失败</p>
          </div>
          <el-form-item>
            <el-button
              style="margin-left: 0.5rem; margin-right: 0.5rem"
              type="primary"
              @click="submitForm('ruleForm')"
              >编辑</el-button
            >
            <el-button type="primary" @click="goReturn">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js"
import { BASE_URL } from "@/utils/base.js"
import { addProgram, getProgramList } from "@/api/user.js"
import Editor from "@/components/editor"
import { Loading } from "element-ui"
import moment from "moment"
let loading
// 使用Elem loading-start方法
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "上传中···",
    background: "rgba(0,0,0,0.7)",
  })
}

// 使用Elem loading-close方法
function endLoading() {
  loading.close()
}
export default {
  name: "Home",
  data() {
    return {
      ruleForm: {},
      rules: {
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        itemserial: [
          { required: true, message: "请输入项目编号", trigger: "blur" },
        ],
        donateask: [
          { required: true, message: "请输入项目详情", trigger: "blur" },
        ],
        donatefor: [
          { required: true, message: "请输入捐赠要求", trigger: "blur" },
        ],
        applyfor: [
          { required: true, message: "请输入申请条件", trigger: "blur" },
        ],
        account: [
          { required: true, message: "请输入账户信息", trigger: "blur" },
        ],
        placement: [
          { required: true, message: "请输入募集目标金额", trigger: "blur" },
          { type: "number", message: "募集目标金额必须为数字值" },
        ],
        donatime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "blur",
          },
        ],
      },
      programInfo: new FormData(),
      videofileList: [],
      pictfileList: [],
      progressFlag: false, //进度条初始值隐藏
      progressPercent: 0, //进度条初始值
    }
  },
  mounted() {
    if (this.$route.params.pid) {
      this.getOneProgram()
    } else {
      this.$router.go(-1)
    }
    this.$nextTick(function() {
      Bus.$emit("getCmsCurrent", "/myProgram")
    })
  },
  methods: {
    // 获取项目详情
    async getOneProgram() {
      let programId = new FormData()
      programId.append("sids", this.$route.params.pid)
      let programDetail = await getProgramList(programId)
      this.ruleForm = programDetail
      if (this.ruleForm.video) {
        this.ruleForm.video = BASE_URL + this.ruleForm.video
      }
      if (this.ruleForm.picture) {
        this.ruleForm.picture = BASE_URL + this.ruleForm.picture
      }
      if (this.ruleForm.placement) {
        this.ruleForm.placement = Number(this.ruleForm.placement)
      }
      this.ediorTime = setTimeout(() => {
        this.$refs.editEditor.$emit("add", this.ruleForm.donateask)
      }, 200)
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let paramFormData = new FormData()
          if (this.pictfileList.length) {
            this.pictfileList.forEach((file) => {
              paramFormData.append("uploadFiles", file.raw)
              // paramFormData.append("fileNames", file.name);
            })
          }
          if (this.videofileList.length) {
            this.videofileList.forEach((file) => {
              paramFormData.append("uploadFiles", file.raw)
            })
          }
          //修改progressFlag值
          this.progressFlag = true
          let onUploadProgress = (progressEvent) => {
            // progressEvent.loaded:已上传文件大小
            // progressEvent.total:被上传文件的总大小
            //进度条
            this.progressPercent =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0
          }
          paramFormData.append("name", this.ruleForm.name)
          paramFormData.append("itemserial", this.ruleForm.itemserial)
          paramFormData.append("applyfor", this.ruleForm.applyfor)
          paramFormData.append("placement", this.ruleForm.placement)
          paramFormData.append("account", this.ruleForm.account)
          paramFormData.append("donatefor", this.ruleForm.donatefor)
          paramFormData.append("donateask", this.ruleForm.donateask)
          paramFormData.append("ikey", Date.now())
          paramFormData.append("uid", this.$store.state.user.userInfo.id)
          paramFormData.append(
            "donatime",
            moment(this.ruleForm.donatime).format("YYYY-MM-DD")
          )
          // paramFormData.append("ikey", Date.now());
          paramFormData.append("status", 1)
          paramFormData.append("id", this.$route.params.pid)
          let program = await addProgram(paramFormData, onUploadProgress)
          if (program.code == "OK") {
            this.$router.go(-1)
            this.cancel()
            this.$message.success("编辑成功")
          } else {
            this.$message.error(program.msg)
          }
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 返回
    goReturn() {
      this.cancel()
      this.$router.go(-1)
    },
    // 取消
    cancel() {
      // paramFormData = new FormData();
      this.$refs.editEditor.$emit("del")
      this.ruleForm = {
        name: "",
        itemserial: "",
        donateask: "",
        donatefor: "",
        applyfor: "",
        account: "",
        placement: "",
        picture: "",
        video: "",
      }
      this.pictfileList = []
      this.videofileList = []
    },
    //富文本
    catchData(content) {
      this.ruleForm.donateask = content
    },
    pictbeforeAvatarUpload(file) {
      // paramFormData.append("uploadFiles", file);
      return false
    },
    fpictbeforeAvatarUpload(file) {
      // paramFormData.append("uploadFiles", file);
      return false
    },
    picthandleChange(file, fileList) {
      const isJPG =
        file.raw.type == "image/png" ||
        file.raw.type == "image/jpg" ||
        file.raw.type == "image/jpeg"
      const isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error("项目封面图片只能是 png/jpg/jpeg 格式!")
      }
      if (!isLt2M) {
        this.$message.error("项目封面不能超过 10MB!")
      }
      if (!isJPG || !isLt2M) {
        this.pictfileList = []
      } else {
        this.pictfileList = fileList.slice(-3)
        this.ruleForm.picture = URL.createObjectURL(file.raw)
      }
    },
    fpicthandleChange(file, fileList) {
      const isJPG = file.raw.type === "video/mp4"
      const isLt2M = file.raw.size / 1024 / 1024 < 2000
      if (!isJPG) {
        this.$message.error("介绍视频只能是 mp4 格式!")
      }
      if (!isLt2M) {
        this.$message.error("视频大小不能超过 2000MB!")
      }
      if (!isJPG || !isLt2M) {
        this.videofileList = []
      } else {
        this.videofileList = fileList.slice(-3)
        this.ruleForm.video = URL.createObjectURL(file.raw)
      }
    },
  },
  components: { Editor },
  destroyed() {
    clearTimeout(this.ediorTime)
  },
}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  padding: 10px 0 40px;
  margin-bottom: 60px;
  .userInfo {
    margin: 0 50px;
    .header {
      width: 100%;
      .pHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
          margin: 20px 0;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }
        h2 {
          width: 100px;
          height: 26px;
          line-height: 26px;
          color: #fff;
          font-size: 12px;
          border-radius: 5px;
          text-align: center;
          background-color: #0687c8;
          cursor: pointer;
        }
      }

      .line {
        width: 100%;
        background-color: #dbdbdb;
        height: 1px;
      }
    }
    .upload {
      .demo-ruleForm {
        margin-top: 20px;
        .fileShow {
          display: flex;
          span {
            margin-left: -70px;
            margin-right: 20px;
            font-size: 14px;
            color: #4d4d4d;
          }
          .avatar-uploader {
            display: flex;
            /deep/.el-upload-list--picture-card {
              display: flex;
              .el-upload-list__item {
                width: 150px;
                height: 150px;
              }
            }
            /deep/ .el-upload--picture-card {
              width: 150px;
              height: 150px;
              position: relative;
              .avatar {
                position: absolute;
                top: 0;
                left: 0;
                width: 150px;
                height: 150px;
              }
              video {
                position: absolute;
                top: 0;
                left: 0;
                width: 150px;
                height: 150px;
              }
              i {
                font-size: 30px;
                position: absolute;
                top: 60px;
                left: 60px;
              }
            }
          }
        }
        .process {
          margin-left: 100px;
          p {
            margin-top: 20px;
            color: red;
            margin-bottom: -10px;
            font-size: 12px;
          }
        }
        .el-form-item__content {
          .el-button {
            width: 120px;
            margin: 40px 0;
          }
        }
        // /deep/ .w-e-toolbar {
        // flex-wrap: wrap;
        // }
      }
    }
  }
}
</style>
